import { subYears } from 'date-fns';

import type { AppConfig } from '../types';

import { FormatDate } from '../utils';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

const config: AppConfig = {
  cloud: {
    defaults: {
      apiBaseUrl: API_BASE_URL || '',
      tenantDomain:
        hostname.includes('localhost') || hostname.includes('127.0.0.1')
          ? CLOUD_DEFAULT_TENANT_DOMAIN
          : hostname,
    },
  },
  components: {
    api: {
      defaultTableOffsetSize: 1,
      defaultTablePaginationSize: 25,
    },
    input: {
      debounce: 500,
    },
    select: {
      debounce: 500,
    },
  },
  environment: {
    isDev: APP_ENV === 'dev',
    isLocal: APP_ENV === 'local',
    isProd: APP_ENV === 'prod',
    isStaging: APP_ENV === 'staging',
  },
  features: {
    isStripeEnabled: IS_STRIPE_ENABLED === 'true',
  },
  images: {
    resizeOrigins: IMAGE_RESIZE_ORIGINS || '',
  },
  firebase: {
    apiKey: FIREBASE_API_KEY || '',
    appId: FIREBASE_APP_ID || '',
    authDomain: FIREBASE_AUTH_DOMAIN || '',
    measurementId: FIREBASE_MEASUREMENT_ID || '',
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID || '',
    projectId: FIREBASE_PROJECT_ID || '',
    storageBucket: FIREBASE_STORAGE_BUCKET || '',
  },
  onboarding: {
    defaultTimezone: FormatDate.currentTimezone(),
    miniumDateOfBirthDate: subYears(new Date(), 16),
  },
  sentry: {
    dsn: SENTRY_DSN || '',
    env: APP_ENV || '',
    organization: SENTRY_ORG || '',
    project: SENTRY_PROJECT || '',
    release: SENTRY_RELEASE || '',
    tracePropagationTargets: (SENTRY_TRACE_PROPAGATION_TARGETS ?? '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean),
  },
};

export default config;
